{
  "version": 1,
  "asset_id": "7d3444fb-66ad-482d-80f2-373ed22d4304",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/7d3444fb-66ad-482d-80f2-373ed22d4304/ind-saas-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/7d3444fb-66ad-482d-80f2-373ed22d4304/ind-saas-640.webp",
  "original_filename": "ind-saas-640.webp",
  "size": 6584,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:15Z"
}
